// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"39443642","52":"a6c79423","160":"2c4f9b91","208":"3d2957be","293":"90e12748","516":"3cd3b73d","519":"6a5074d0","917":"47fd363c","946":"0049b334"}[chunkId] + ".chunk.js";
};